import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Box, Button, Paper, Typography, Table, TableContainer, TableHead, TableBody, TableRow, TableCell, IconButton } from '@mui/material';
import PrintIcon from '@mui/icons-material/Print';
import AttestedModal from "../attested/attestedModal";
import api from "../../../api/api";
import Loading from '../../../components/loading';
import SuccessMessage from '../../../components/successMessage';
import ErrorMessage from '../../../components/errorMessage';

export default function AttestedList() {

    const navigate = useNavigate();

    const { patientId } = useParams();

    const [isLoading, setLoading] = useState(false);
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [showErrorMessage, setShowErrorMessage] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const [attesteds, setAttesteds] = useState([]);
    const [isModalOpen, setModalOpen] = useState(false);

    const getAttestedsFromPatient = useCallback(() => {
        if (!patientId) {
            return;
        }
        setLoading(true);
        api.get(`/atestado/${patientId}`, {
            headers: {
                Authorization: sessionStorage.getItem('token')
            }
        })
        .then((returnFromApi) => {
            setAttesteds(returnFromApi.data);
            setLoading(false);
        })
        .catch((returnFromApi) => {
                setLoading(false);
                console.error("ops! ocorreu um erro" + returnFromApi);
                setErrorMessage(returnFromApi.response.data);
                if (returnFromApi.status === 401) {
                    navigate("/expired-session");
                }        
        });
    }, [navigate, patientId]);

    useEffect(() => {
        getAttestedsFromPatient();
    }, [patientId, getAttestedsFromPatient]);

    const saveAttested = (returnFromApi) => {
        if (returnFromApi.data) {
            setShowSuccessMessage(true);
            setSuccessMessage(returnFromApi.data);
        } else {
            setShowErrorMessage(true);
            setErrorMessage(returnFromApi.response.data);
        }
        setModalOpen(false);
        getAttestedsFromPatient();
    };

    const printAttested = (attestedId) => {
        window.open(`/attested-to-print/${patientId}/${attestedId}`, "_blank");
    };

    return (
        <>
            <Loading isToHidden={isLoading === false} />
            {showSuccessMessage && <SuccessMessage message={successMessage} show={showSuccessMessage} setShow={setShowSuccessMessage} />}
            {showErrorMessage && <ErrorMessage message={errorMessage} show={showErrorMessage} setShow={setShowErrorMessage} />}


            <Paper variant="outlined" sx={{ p: 3, borderRadius: 2 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                    <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
                        Atestados
                    </Typography>
                    <Button variant="outlined" onClick={() => setModalOpen(true)}>
                        Adicionar Atestado
                    </Button>
                </Box>

                {attesteds.length === 0 ? (
                    <Typography align="center" sx={{ py: 4 }}>
                        Nenhum atestado cadastrado ainda.
                    </Typography>
                ) : (
                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={{ fontWeight: 'bold' }}>Data</TableCell>
                                    <TableCell sx={{ fontWeight: 'bold' }}>Dentista</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid rgba(224, 224, 224, 1)' }}></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {attesteds.map(attested => (
                                    <TableRow key={attested.id} hover>
                                        <TableCell>{attested.data}</TableCell>
                                        <TableCell>{attested.nomeDoDentista}</TableCell>
                                        <TableCell align="right">
                                            <IconButton color="primary"
                                                onClick={() => printAttested(attested.id)}>
                                                <PrintIcon />
                                            </IconButton>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
            </Paper>

            <AttestedModal
                open={isModalOpen}
                onClose={() => setModalOpen(false)}
                onAttestedSave={saveAttested}
            />
        </>
    )
}